import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaChgDoc.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(DOC)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'DOC'},
            ]
        },
    })
}
